import React, { useState } from "react";
import "./PersonCard.css";
import iq_api_v2 from "../../../../../services/iqApiV2";
import { useUser } from "../../../../../context/UserContext";
import { useDispatch } from "react-redux";
import { FetchSpotContactsRequest } from "../../../../../store/features/actions/targetedReachout/spotContactsActions";
import { useParams } from "react-router-dom";
import PostSaveContainer from "../postSaveContainer/PostSaveContainer";
import { useTaskStatus } from "../../../../../context/TaskStatusContext";
import { WSS_URL } from "../../../../../config/apiConfig";
import IOSSpinner from "../../../../HtmlElements/IOSSpinner";

const PersonCard = ({ person }) => {
  const [imageError, setImageError] = useState(false);
  const [contactSaved, setContactSaved] = useState(false);
  const [errMsg, setErrMsg] = useState("");
  const [loading, setLoading] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [currentTaskId, setCurrentTaskId] = useState(false);
  const { user } = useUser();
  const dispatch = useDispatch();
  const { registerTask, deregisterTask } = useTaskStatus();
   
  const { clientName, accountName } = useParams();

  const handleTagAndSaveContact = async () => {
    try {
      setLoading(true);
      setErrMsg("");

      const payload = {
        user_id: user?.id,
        linkedin_url: person.linkedin_url,
        client: clientName,
        account: accountName,
      };

      const res = await iq_api_v2.post("contact/add_contact_async", payload);

      if (res?.status === 200) {
        setContactSaved(true);
        if (res?.data) {
       const taskID = `${WSS_URL}/${res?.data?.task_id}`
       const addContactTask = user?.id+"_FIND_AND_ADD_"+"_"+taskID;
       setCurrentTaskId(addContactTask)
       registerTask(addContactTask,taskID)
        
        }
      } else {
        throw new Error("API response status not 200");
      }
    } catch (error) {
      console.error("❌ Error in handleTagAndSaveContact:", error);
      setErrMsg(error?.response?.data?.detail || "Something went wrong");
      setContactSaved(false);
    } finally {
      setLoading(false);
    }
  };

  const getInitials = (name) => {
    if (!name) return "";
    const [first, last] = name.split(" ");
    return `${first?.[0] || ""}${last?.[0] || ""}`.toUpperCase();
  };

  return (
    <div className="person-card-container">
      <div className="person-card-header">
        {imageError || !person.photo_url ? (
          <div className="person-card-initials-fallback">
            {getInitials(person.name)}
          </div>
        ) : (
          <img
            src={person.photo_url}
            alt={person.name}
            className="person-card-profile-pic"
            onError={() => setImageError(true)}
          />
        )}
      </div>

      <div className="person-card-info">
        <h3 className="person-card-name">{person.name}</h3>
        <p className="person-card-title">{person.title}</p>
        <p className="person-card-org">{person.organization?.name}</p>
        <p className="person-card-location">
          {person.city}, {person.country}
        </p>

        {person.linkedin_url && (
          <p>
            LinkedIn:{" "}
            <a href={person.linkedin_url} target="_blank" rel="noreferrer">
              View Profile
            </a>
          </p>
        )}

        <div className="person-card-button-row">
         
            {loading ? <IOSSpinner/> : contactSaved ?  <PostSaveContainer onStop={()=>deregisterTask(currentTaskId)}  taskId={currentTaskId} postAction={()=>{dispatch(
            FetchSpotContactsRequest({
              clientName,
              accountName,
              userId: user?.id,
              type: "spot",
            })
          );}}/> : <button
            className="person-card-toggle-btn"
            onClick={handleTagAndSaveContact}
            disabled={contactSaved || loading}
          > Save Contact</button>}
          

         

          <button
            className="circle-toggle-btn"
            onClick={() => setShowDetails((prev) => !prev)}
            title={showDetails ? "Hide Details" : "View Details"}
          >
            <span className={`arrow-icon ${showDetails ? "up" : "down"}`}/>
          </button>
        </div>

        {errMsg && (
          <div className="person-card-error-box">
            <h6>{errMsg}</h6>
          </div>
        )}

        {showDetails && (
          <div className="person-card-more">
            <p>
              Email Status: <strong>{person.email_status}</strong>
            </p>
            {person.employment_history?.length > 0 && (
              <ul className="person-card-job-history">
                {person.employment_history.slice(0, 3).map((job) => (
                  <li key={job.id}>
                    {job.title} @ {job.organization_name}
                  </li>
                ))}
              </ul>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default PersonCard;
